import { gql } from 'apollo-boost';
import { useQuery } from 'react-apollo';
import { removeConnectionsMemoized } from '../';

const query = gql`
  query reportAnswers($id: ID) {
    allReports(filters: { id: $id }) {
      edges {
        node {
          dbId
          selectedServiceId
          serviceName
          indicators {
            edges {
              node {
                dbId
                name
                stageId
                definition
              }
            }
          }
        }
      }
    }
  }
`;

export const queryWithResults = gql`
  query reportAnswers($id: ID) {
    allReports(filters: { id: $id }) {
      edges {
        node {
          dbId
          selectedServiceId
          serviceName
          indicators {
            edges {
              node {
                dbId
                name
                stageId
                definition
              }
            }
          }
          results {
            edges {
              node {
                dbId
                indicatorId
                forecastCurrent
                description
                classification
                attachment
                attachmentId
              }
            }
          }
        }
      }
    }
  }
`;

export const useReportData = (reportId, withResults = false) => {
  if (!reportId || reportId === 'new') {
    return { data: {}, refetch: () => { /* noop */ }, loading: false };
  }
  const baseQuery = withResults ? queryWithResults : query;
  const { data: rawData, refetch, loading } = useQuery(baseQuery, {
    variables: { id: reportId },
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  });
  const data =
    rawData?.allReports?.edges.length > 0
      ? removeConnectionsMemoized(rawData?.allReports)
      : [];
  return { data: data?.[0] ?? {}, refetch, loading };
};
